import { DEFAULT_ERROR } from '@/constants/messages'
import { TOAST_TYPE } from '@/constants/toasts'
import EventBus from '@/EventBus'
import * as R from 'ramda'

/**
 * This shows API error in Toast
 * @param e - This is argument of catch function
 */
export default (e, errorFieldLookupPath = [], defaultError = DEFAULT_ERROR, dismissAfter) => {
  console.error('API Error', e)
  const response = e?.response?.data
  let fieldError = errorFieldLookupPath.length > 0 && R.path(errorFieldLookupPath, response)
  if (Array.isArray(fieldError)) {
    fieldError = fieldError[0]
  }
  const genericMessage = response?.message
  const message = fieldError || genericMessage || defaultError
  EventBus.$emit('ADD_TOAST', { message, type: TOAST_TYPE.ERROR, dismissAfter })
}
